import { defineComponent as _defineComponent } from 'vue'
import { createTextVNode as _createTextVNode, createElementVNode as _createElementVNode, normalizeClass as _normalizeClass, normalizeStyle as _normalizeStyle, unref as _unref, resolveDirective as _resolveDirective, createVNode as _createVNode, withDirectives as _withDirectives, toDisplayString as _toDisplayString, withCtx as _withCtx, openBlock as _openBlock, createBlock as _createBlock } from "vue"

const _hoisted_1 = /*#__PURE__*/_createElementVNode("span", null, "Documente necesare la înrolarea în DoctorApp", -1)
const _hoisted_2 = { class: "card" }
const _hoisted_3 = { class: "file-item" }
const _hoisted_4 = ["onClick"]
const _hoisted_5 = ["onClick"]
const _hoisted_6 = /*#__PURE__*/_createElementVNode("i", { class: "pi pi-download" }, null, -1)
const _hoisted_7 = [
  _hoisted_6
]
const _hoisted_8 = /*#__PURE__*/_createElementVNode("br", null, null, -1)

import DataTable from 'primevue/datatable';
import Column from 'primevue/column';
import Card from 'primevue/card';
import Tag from 'primevue/tag';
import {
  computed,
  onMounted,
  PropType,
  ref,
  Ref,
  watch
} from 'vue';
import DoctorService from '@/services/DoctorService';
import { FileTypeSerializer, File } from '@/enums/FileType';
import { Doctor } from '@/interfaces/Doctor';
import Toast from 'primevue/toast';
import { useToast } from 'primevue/usetoast';
import FileUpload from 'primevue/fileupload';

const MAX_FILE_SIZE = 10000000;


export default /*#__PURE__*/_defineComponent({
  __name: 'DoctorFiles',
  props: {
  doctor: {
    type: Object as PropType<Doctor>,
    default: () => null
  },
  collect: {
    type: Boolean,
    default: () => false
  }
},
  setup(__props) {

const props = __props;

const doctor = ref<Doctor>(props.doctor || ({} as Doctor));
const documents: Ref<File[] | null> = ref(null as File[] | null);
const toast = useToast();
const collect = ref<boolean>(props.collect || false);
const collection = ref(new Map());

watch(
  () => props.doctor,
  (newValue) => {
    doctor.value = newValue;
    documents.value = FileTypeSerializer.deserialize(doctor.value.docSet);
  }
);

onMounted(() => {
  if (!documents.value) {
    documents.value = FileTypeSerializer.deserialize(0);
    doctor.value.documents = new Map();
  }
});

const recomputeDocSet = () => {
  let newDocSet = 0;
  doctor.value.documents?.forEach((_, key) => {
    const keynum = Number(key);
    newDocSet += keynum;
  });
  doctor.value.docSet = newDocSet;
};

const onDownload = async (docSetId) => {
  if (doctor.value && (doctor.value.docSet & docSetId) == docSetId) {
    if (collect.value) {
      const file = collection.value.get(docSetId);
      const url = window.URL.createObjectURL(file);
      const a = document.createElement('a');
      a.href = url;
      a.download = file.name;
      document.body.appendChild(a);
      a.click();
    } else {
      const { file, fileName } = await DoctorService.fetchDoctorDocument(
        doctor.value.id,
        docSetId
      );
      const url = window.URL.createObjectURL(file);
      const a = document.createElement('a');
      a.href = url;
      a.download = fileName;
      document.body.appendChild(a);
      a.click();
    }
  }
};

const invalidFileSizeMessage = computed(() => {
  return `Dimensiunea fișierului este mai mare de ${MAX_FILE_SIZE / 1000000} MB.`;
});

const onFileUploadError = (event) => {
  if (event.error === 'invalidFileSize') {
    console.log('invalidFileSizeMessage.value', invalidFileSizeMessage.value);
    toast.add({
      severity: 'error',
      summary: 'Eroare',
      detail: invalidFileSizeMessage.value
    });
  }

  if (event.error === 'genericError') {
    toast.add({
      severity: 'error',
      summary: 'Eroare',
      detail: 'A apărut o eroare la încărcarea documentului'
    });
  }
};

const onUpload = async (event, docSetId) => {
  if (event.files && doctor.value) {
    const file = event.files[0];
    if (file.size > MAX_FILE_SIZE) {
      onFileUploadError({ error: 'invalidFileSize' });
      return;
    }

    // Remove the existing file from the collection and doctor documents
    collection.value.delete(docSetId);
    doctor.value.documents?.delete(docSetId);

    if (collect.value) {
      collection.value.set(docSetId, file);
      doctor.value.documents?.set(docSetId, file);
      recomputeDocSet();
      documents.value = FileTypeSerializer.deserialize(doctor.value.docSet);
    } else {
      try {
        await DoctorService.saveDoctorDocument(doctor.value.id, docSetId, file);
        toast.add({
          severity: 'success',
          summary: 'Succes',
          detail: 'Documentul a fost adaugat cu succes'
        });
        recomputeDocSet();
      } catch (error) {
        onFileUploadError({ error: 'genericError' });
      }
    }
  }
};

const onRemove = (docSetId) => {
  if (doctor.value) {
    collection.value.delete(docSetId);
    doctor.value.documents?.delete(docSetId);
    recomputeDocSet();
    documents.value = FileTypeSerializer.deserialize(doctor.value.docSet);
  }
};

return (_ctx: any,_cache: any) => {
  const _directive_tooltip = _resolveDirective("tooltip")!

  return (_openBlock(), _createBlock(_unref(Card), null, {
    title: _withCtx(() => [
      _createTextVNode(" Documente ")
    ]),
    subtitle: _withCtx(() => [
      _hoisted_1
    ]),
    content: _withCtx(() => [
      _createElementVNode("div", null, [
        _createElementVNode("div", _hoisted_2, [
          _createVNode(_unref(DataTable), {
            size: "small",
            stripedRows: "",
            value: documents.value
          }, {
            default: _withCtx(() => [
              _createVNode(_unref(Column), null, {
                body: _withCtx((slotProps) => [
                  _createElementVNode("span", _hoisted_3, [
                    _createElementVNode("i", {
                      class: _normalizeClass(
                      slotProps.data.present ? 'pi pi-check' : 'pi pi-times'
                    ),
                      style: _normalizeStyle(
                      slotProps.data.present ? 'color: green' : 'color: red'
                    )
                    }, null, 6),
                    _withDirectives(_createVNode(_unref(Tag), {
                      rounded: "",
                      icon: "pi pi-info-circle text-lg",
                      class: "text-black-alpha-90 bg-white"
                    }, null, 512), [
                      [
                        _directive_tooltip,
                        {
                      value: slotProps.data.info.tooltip,
                      showDelay: 100,
                      hideDelay: 300
                    },
                        void 0,
                        { right: true }
                      ]
                    ]),
                    _createElementVNode("a", {
                      class: _normalizeClass(
                      (doctor.value.docSet & slotProps.data.value) ==
                      slotProps.data.value
                        ? 'font-normal pb-1 sm:text-base text-sm '
                        : 'not-downloadable font-normal sm:text-base text-sm  pb-1'
                    ),
                      onClick: ($event: any) => (onDownload(slotProps.data.value))
                    }, _toDisplayString(slotProps.data.info.name), 11, _hoisted_4)
                  ])
                ]),
                _: 1
              }),
              _createVNode(_unref(Column), null, {
                body: _withCtx((slotProps) => [
                  _createTextVNode(_toDisplayString(slotProps.background) + " ", 1),
                  _createElementVNode("a", {
                    onClick: ($event: any) => (onDownload(slotProps.data.value)),
                    class: _normalizeClass(
                    (doctor.value.docSet & slotProps.data.value) ==
                    slotProps.data.value
                      ? 'custom-download-button #3b82f6'
                      : 'custom-download-button disabled'
                  )
                  }, _hoisted_7, 10, _hoisted_5)
                ]),
                _: 1
              }),
              _createVNode(_unref(Column), null, {
                body: _withCtx((slotProps) => [
                  _createTextVNode(_toDisplayString(slotProps.background) + " ", 1),
                  _createVNode(_unref(FileUpload), {
                    unstyled: "",
                    chooseLabel: "Incarca",
                    mode: "basic",
                    url: "/api/upload",
                    "choose-icon": "pi pi-times",
                    onSelect: ($event: any) => (onUpload($event, slotProps.data.value)),
                    onError: ($event: any) => (onRemove(slotProps.data.value)),
                    pt: {
                    chooseButton: {
                      class: 'custom-choose-button'
                    }
                  }
                  }, null, 8, ["onSelect", "onError"])
                ]),
                _: 1
              })
            ]),
            _: 1
          }, 8, ["value"]),
          _hoisted_8
        ])
      ])
    ]),
    _: 1
  }))
}
}

})